module.exports = __webpack_public_path__ + "img/prev.a385e358.svg";